// removed by extract-text-webpack-plugin
module.exports = {"horizontalRadios":"_3mCnvP2L9iFkbovlHLEg9K"};


//////////////////
// WEBPACK FOOTER
// ./lib/tcomb-types.module.css
// module id = 2376
// module chunks = 1